document.addEventListener("DOMContentLoaded", function () {
  const cartDot = document.querySelector(".header__cart-dot");

  // Funktion zum Abrufen des Warenkorb-Inhalts
  function updateCartDot() {
    fetch("/cart.js")
      .then(response => response.json())
      .then(cart => {
        const itemCount = cart.item_count;

        if (itemCount > 0) {
          cartDot.textContent = itemCount;
          cartDot.classList.add("is-visible");
        } else {
          cartDot.textContent = "";
          cartDot.classList.remove("is-visible");
        }
      })
      .catch(error => console.error("Fehler beim Abrufen des Warenkorbs:", error));
  }

  // Initiales Update beim Laden der Seite
  updateCartDot();

  // Event Listener für Shopify-Ereignisse
  document.addEventListener("cart:updated", updateCartDot);

  // Zusätzlicher Event-Listener für den Cart-Drawer
  const cartDrawer = document.querySelector(".cart-drawer"); // Passe den Selektor an, falls nötig

  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      updateCartDot();
    });

    // Überwache Änderungen im Cart-Drawer
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  // Optional: Event manuell auslösen, falls nötig
  // document.dispatchEvent(new CustomEvent("cart:updated"));
});
